/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Defines scope access for a Container/Document.
 * @legacy
 * @alpha
 */
export var ScopeType;
(function (ScopeType) {
    /**
     * Read access is supported on the Container/Document
     */
    ScopeType["DocRead"] = "doc:read";
    /**
     * Write access is supported on the Container/Document
     */
    ScopeType["DocWrite"] = "doc:write";
    /**
     * User can generate new summaries operations
     */
    ScopeType["SummaryWrite"] = "summary:write";
})(ScopeType || (ScopeType = {}));
//# sourceMappingURL=scopes.js.map